import React from "react";
import ReactGA from 'react-ga';
import Link from "react-router-dom/Link";
import Page from "../Page";
import restartSVG from "img/restart.svg";
import stock from "img/stock.png";
import check from "img/check.svg";

export default function Solution({ resetData }) {
  ReactGA.pageview('/solution/3')
  return (
    <Page>
      <div className="solution-page">
        <div className="introduction-page__restart-block">
          <ul className="arrival-page__arms-list">
            <li className="in-red">A</li>
            <li className="in-red">R</li>
            <li className="full-word">Manage</li>
            <li className="in-red">S</li>
          </ul>
          <Link
            to={{ pathname: "/login", state: { prev: true } }}
            className="introduction-page__restart-btn"
            href="#"
            onClick={resetData}
          >
            <img
              className="introduction-page__restart-icon"
              src={restartSVG}
              alt=""
            />
            <span>Restart</span>
          </Link>
        </div>
        <div className="problem-page__main-section">
          <div className="problem-page__image-container">
            <img className="problem-page__image" src={stock} alt="" />
          </div>
          <div className="problem-page__investigate-block">
            <img className="problem-page__bang-circle" src={check} alt="" />
            <h1>Manage On-Hand Quantities</h1>
            <p>
              Regular counts of on-hand quantities ensure in-stock position and
              drive replenishment. It’s important to feed the cage! Our cashier
              completes the transaction by ordering the Nest Camera for pick-up
              at a nearby store. The cashiers should work with the department
              supervisor to ensure the on-hand quantity is accurate.
            </p>
            <Link to="/conclusion" className="btn login-page__start-btn">
              <span className="white-background">Continue</span>
            </Link>
          </div>
        </div>
      </div>
    </Page>
  );
}
